import { render, staticRenderFns } from "./Pop2.vue?vue&type=template&id=061cb3ee&scoped=true&"
import script from "./Pop2.vue?vue&type=script&lang=js&"
export * from "./Pop2.vue?vue&type=script&lang=js&"
import style0 from "./Pop2.vue?vue&type=style&index=0&id=061cb3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061cb3ee",
  null
  
)

export default component.exports